module.exports = __webpack_public_path__ + "static/media/1015827.a7ded18d.png";